import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { undo, redo } from '../../actions/wysiwyg/editor';

import type { TStencilStore } from '../../types/Stencil';
import Undo from '../wysiwyg_editor/Undo';

function StencilUndo(): React.ReactElement {
  const dispatch = useDispatch();
  const canUndo = useSelector(
    (state: TStencilStore) => state.submission.history.undo.length > 0
  );
  const canRedo = useSelector(
    (state: TStencilStore) => state.submission.history.redo.length > 0
  );

  return (
    <Undo
      klass="stencil-undo"
      onUndo={canUndo ? () => dispatch(undo()) : null}
      onRedo={canRedo ? () => dispatch(redo()) : null}
    />
  );
}

export default StencilUndo;
